<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-06 14:09:02
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-16 16:22:19
-->
<template>
<div class="page page_fans page_adress page-agent-trade">
	<div class="list-wrap" v-if="dataList">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="getData">
			<div class="list">
				<div class="item" v-for="(item,index) in dataList" :key="index" @click.stop="toPush(item)">
					<div class="item_l">
						<img :src="item.thumb ? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
						<div class="">
							<div class="user_name slh_s">{{ item.nickname }}</div>
							<div class="push-status" v-if="item.is_push == 2">已推荐</div>
						</div>
					</div>
					<div class="item_r action-wrap">
						<!-- <div class="action" @click.stop="clickBindBtn(item)">绑定</div> -->
						<div class="action unfollow" @click.stop="cancleAgent(item,index)">已代理</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
    <!-- 无粉丝 -->
    <div class="page_default" v-if="!dataList">
        <div class="bg">
            <img :src="publicPath+'statics/images/no_fans.png'" alt="" class="bg_tu">
        </div>
        <div class="tips">还没有代理匠人呦～</div>
    </div>
    <!-- 添加匠人 -->
    <div class="bottom">
        <div class="action_add" @click="addTradesman">添加匠人</div>
    </div>
	<!-- 20230307 添加匠人改到新页面tradesmanAdd.vue去处理 -->
    <!-- <van-popup v-model="tradesPicker" position="bottom">
        <van-picker show-toolbar :columns="tradesList" value-key="name" @cancel="tradesPicker = false" @confirm="confrimTrades" />
    </van-popup> -->
	<van-dialog v-model="showBind" title="绑定" show-cancel-button @confirm="confirmBind">
		<div class="bind-wrap">
			<van-field v-model="qrcodeNum" placeholder="请输入二维码编号或扫码识别">
				<template #button>
					<van-icon name="scan" size="0.6rem" color="#333333" @click="scaneCode" />
				</template>
			</van-field>
		</div>
	</van-dialog>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			qrcodeNum: null,
			showBind: false,
            publicPath: process.env.BASE_URL,
            token: null,
			page: 1,
			size: 10,
			loading: true,
			finished: false,
            dataList: [],
            tradesList: [],
            tradesPicker: false,
            imageUrl: this.$publicData.uploadImage,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '代理商匠人'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData();
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            this.getData();
        }
        // // 获取列表
        // this.getData();
    },
    mounted() {

    },
    methods: {
		/**
		 * @name: 推送
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */		
		toPush(item){
			this.$router.push({
				path: '/agent/tradesman/push',
				query: {
					trad_uuid: item.uuid,
					is_push: item.is_push,
					nickname: item.nickname,
					thumb: item.thumb,
					sort: item.sort
				}
			})
		},
		/**
		 * @name: 扫码
		 * @return {*}
		 * @desc: 
		 */		
		scaneCode(){
			let that = this;
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
				success: function(res) {
					console.log('扫码成功res',res);
					let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
					let params = that.getUrlParams(result);
					if(params.code){
						that.qrcodeNum = params.code;
					}else{
						that.$toast('二维码有误，请联系相关人员');
					}
				},
				fail: function(err) {
					that.$toast('扫码失败');
					console.log('调扫码失败，'+ err);
				}
			});
		},
		/**
		 * @name: 截取url的参数
		 * @param {*} url
		 * @return {*}
		 * @desc: 
		 */		
		getUrlParams(url){
			let theRequest = new Object();
			if(url.indexOf('?') != -1){
				let index = url.indexOf('?');
				let params = url.slice(index+1,url.length);
				let paramsArr = params.split('&');
				for (let i = 0; i < paramsArr.length; i++) {
					theRequest[paramsArr[i].split("=")[0]] = paramsArr[i].split("=")[1];
				}
			};
			return theRequest;
		},
		/**
		 * @name: 点击绑定按钮
		 * @param {*} item
		 * @return {*}
		 * @desc: 
		 */	
		clickBindBtn(item){
			this.qrcodeNum = '';
			this.showBind = true;
			this.currentTrade = item;
		},
		/**
		 * @name: 确认绑定
		 * @return {*}
		 * @desc: 
		 */
		confirmBind(){
			if(!this.qrcodeNum){
				this.$toast("请输入二维码编号");
				return;
			};
			let params = {
				token: this.token,
				qrcode_num: this.qrcodeNum,
				trade_uuid: this.currentTrade.tradesman_uuid
			};
			this.$api.agent.tradqrcode(params).then(res=>{
				if(res.code == 200){
					this.$toast(res.message);
					this.showBind = false;
				};
			})
		},
        // 获取列表
        getData() {
            let param = {
                token: this.token,
				page: this.page,
				size: this.size,
            };
            this.$api.agent.tradesman(param).then(res => {
                if (res.code == 200) {
					let list = res.result;
					if(list.length){
						for(let i in list){
							this.dataList.push(list[i]);
						};
						this.page++;
						this.loading = false;
					}else{
						this.finished = true;
					}
                } else {
                    this.finished = true;
                }
            })
        }, 
        /**
         * @name: 跳转可添加匠人页
         * @return {*}
         * @desc: 
         */		
        addTradesman() {
            // this.tradesPicker = true
			this.$router.push({
				path: '/agent/tradesman/add'
			})
        },
        confrimTrades(data, index) {
            this.tradesPicker = false
            var man = this.tradesList[index].id;
            var params = {
                token: this.token,
                trades_uuid: man,
            }
            console.log(params)
            this.$api.my.agentAddTradesman(params).then(res => {
                if (res.code == 200) {
                    this.$toast('添加成功')
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 取消代理
        cancleAgent(item,index) {
            console.log('item', item)
            var params = {
                token: this.token,
                trade_uuid: item.uuid
            }
            this.$api.my.agentDelte(params).then(res => {
                if (res.code == 200) {
                    this.$toast('取消成功')
                    this.dataList.splice(index,1);
                } else {
                    this.$toast(res.message)
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
	.item .push-status{
		padding-left: .25rem;
		font-size: 0.32rem;
		color: rgba(0, 0, 0, 0.54);
	}
</style>
